<template>
  <div class="col-sm-10 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">{{ title }}</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Nombre (*) </label>

                <el-input v-model="formData.name" v-validate="modelValidations.name" name="name" placeholder="Nombre">
                </el-input>

                <small v-show="name.invalid" class="text-danger">
                  {{ getError('name') }}
                </small>
              </div>
            </div>

            <div class="col-sm-6 col-md-3 d-none">
              <div class="form-group">
                <label class="control-label"> Nro. de distribuidor (*) </label>

                <el-input
                  v-model="formData.code"
                  v-validate="modelValidations.code"
                  name="code"
                  placeholder="Número de distribuidor"
                >
                </el-input>

                <small v-show="code.invalid" class="text-danger">
                  {{ getError('code') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> CUIT (*) </label>

                <el-input v-model="formData.cuit" v-validate="modelValidations.cuit" name="cuit" placeholder="CUIT">
                </el-input>

                <small v-show="cuit.invalid" class="text-danger">
                  {{ getError('cuit') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Email (*) </label>

                <el-input v-model="formData.email" v-validate="modelValidations.email" name="email" placeholder="Email">
                </el-input>

                <small v-show="email.invalid" class="text-danger">
                  {{ getError('email') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Email alternativo </label>

                <el-input
                  v-model="formData.alternativeEmail"
                  v-validate="modelValidations.alternativeEmail"
                  name="alternative_email"
                  placeholder="Email alternativo"
                >
                </el-input>

                <small v-show="alternativeEmail.invalid" class="text-danger">
                  {{ getError('alternativeEmail') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Asesor Técnico (*) </label>

                <el-select
                  v-model="formData.seller"
                  v-validate="modelValidations.seller"
                  autocomplete="off"
                  filterable
                  name="seller"
                  placeholder="Asesor Técnico"
                >
                  <el-option
                    v-for="option in sellersOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="seller.invalid" class="text-danger">
                  {{ getError('seller') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Teléfono </label>

                <el-input
                  v-model="formData.phone"
                  v-validate="modelValidations.phone"
                  name="phone"
                  placeholder="Teléfono"
                >
                </el-input>

                <small v-show="phone.invalid" class="text-danger">
                  {{ getError('phone') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Dirección (*) </label>

                <el-input
                  v-model="formData.address"
                  v-validate="modelValidations.address"
                  name="address"
                  placeholder="Dirección"
                >
                </el-input>

                <small v-show="address.invalid" class="text-danger">
                  {{ getError('address') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Dirección de depósito </label>

                <el-input
                  v-model="formData.warehouseAddress"
                  v-validate="modelValidations.warehouseAddress"
                  name="warehouseAddress"
                  placeholder="Dirección de depósito"
                >
                </el-input>

                <small v-show="warehouseAddress.invalid" class="text-danger">
                  {{ getError('warehouseAddress') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label"> Provincia (*) </label>

                <el-select
                  v-model="formData.province"
                  v-validate="modelValidations.province"
                  autocomplete="off"
                  filterable
                  name="province"
                  placeholder="Provincia"
                  @change="clearCity"
                >
                  <el-option
                    v-for="option in provincesOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="province.invalid" class="text-danger">
                  {{ getError('province') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label d-block"> Localidad (*) </label>

                <el-autocomplete
                  v-model="formData.cityName"
                  v-validate="modelValidations.city"
                  :disabled="!formData.province"
                  name="city"
                  class="w-100"
                  placeholder="Localidad"
                  :fetch-suggestions="querySearchAsync"
                  @select="selectCity"
                >
                </el-autocomplete>

                <small v-show="searchError !== ''" class="text-danger d-block">
                  {{ searchError }}
                </small>

                <small v-show="city.invalid" class="text-danger d-block">
                  {{ getError('city') }}
                </small>
              </div>
            </div>

            <server-error :server-errors="serverErrors"></server-error>

            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, Autocomplete } from 'element-ui';
import CityProvinceOptionsMixin from '@/mixins/cityProvinceOptionsMixin';
import { mapFields } from 'vee-validate';
import ServerError from '../../../components/ServerError';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Autocomplete.name]: Autocomplete,
    ServerError,
  },

  mixins: [CityProvinceOptionsMixin],
  props: {
    serverErrors: {
      type: Array,
      default: () => {
        return [];
      },
    },

    title: {
      type: String,
      default: 'Agregar nuevo distribuidor',
    },

    distributor: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: null,
          code: null,
          cuit: null,
          city: null,
          province: null,
          seller: null,
          address: null,
          warehouseAddress: null,
          alternativeEmail: null,
          email: '',
          phone: '',
        };
      },
    },
  },

  data() {
    return {
      sellers: [],
      validated: false,
      formData: {
        code: this.distributor.code,
        cuit: this.distributor.cuit,
        name: this.distributor.name,
        email: this.distributor.email,
        province: null,
        cityName: null,
        city: null,
        seller: this.distributor.seller,
        address: this.distributor.address,
        warehouseAddress: this.distributor.warehouseAddress,
        alternativeEmail: this.distributor.alternativeEmail,
        phone: this.distributor.phone,
      },

      modelValidations: {
        name: {
          required: true,
          min: 5,
        },

        code: {
          // required: true
        },

        cuit: {
          required: true,
          numeric: true,
          length: 11,
        },

        email: {
          required: true,
          email: true,
        },

        alternative_email: {
          email: true,
        },

        seller: {
          required: true,
        },

        province: {
          required: true,
        },

        city: {
          required: true,
        },

        address: {
          required: true,
        },

        phone: {
          min: 10,
          numeric: true,
        },
      },
    };
  },

  computed: {
    ...mapFields([
      'name',
      'code',
      'cuit',
      'province',
      'city',
      'seller',
      'address',
      'warehouseAddress',
      'alternativeEmail',
      'email',
      'phone',
    ]),

    sellersOptions() {
      return this.$selectOptions(this.sellers, { sort: true });
    },
  },

  created() {
    this.$services
      .resource('sellers')
      .get()
      .then((res) => res.data.data)
      .then((data) => {
        this.sellers = data.sellers;
        if (this.sellers.length === 1) {
          this.formData.distributor = this.sellers[0];
        }
      });
  },

  mounted() {
    if (this.distributor.city) {
      this.defaultCity = this.distributor.city.id;
      this.defaultCityName = this.distributor.city.name;
      this.defaultProvince = this.distributor.city.province.id;
    }
  },

  methods: {
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
